"use strict";
var globalThis = require("../internals/global-this");
var NativePromiseConstructor = require("../internals/promise-native-constructor");
var isCallable = require("../internals/is-callable");
var isForced = require("../internals/is-forced");
var inspectSource = require("../internals/inspect-source");
var wellKnownSymbol = require("../internals/well-known-symbol");
var ENVIRONMENT = require("../internals/environment");
var IS_PURE = require("../internals/is-pure");
var V8_VERSION = require("../internals/environment-v8-version");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol("species");
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR = isForced("Promise", function() {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  if (IS_PURE && !(NativePromisePrototype["catch"] && NativePromisePrototype["finally"])) return true;
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    var promise = new NativePromiseConstructor(function(resolve) {
      resolve(1);
    });
    var FakePromise = function(exec) {
      exec(function() {
      }, function() {
      });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function() {
    }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  }
  return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === "BROWSER" || ENVIRONMENT === "DENO") && !NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING
};
